
export default function ContactInfo() {
  return (
    <div className="space-y-6">
      {/* 재기목형 연락처 */}
      <div className="bg-gradient-to-br from-slate-900 to-slate-800 text-white rounded-lg shadow-lg p-8">
        <h3 className="text-xl font-bold mb-6 flex items-center">
          <i className="ri-building-line mr-2 text-amber-400"></i>
          재기목형 본사
        </h3>
        
        <div className="space-y-4">
          <div className="flex items-start">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-phone-fill text-amber-400 text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-slate-300 mb-1">대표전화</p>
              <a href="tel:02-2263-8248" className="text-lg font-bold hover:text-amber-400 transition-colors cursor-pointer">
                02-2263-8248
              </a>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-printer-line text-amber-400 text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-slate-300 mb-1">팩스</p>
              <p className="text-base">02-2263-3616</p>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-mail-line text-amber-400 text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-slate-300 mb-1">이메일</p>
              <a href="mailto:jk8248@hanmail.net" className="text-base hover:text-amber-400 transition-colors cursor-pointer break-all">
                jk8248@hanmail.net
              </a>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-map-pin-line text-amber-400 text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-slate-300 mb-1">주소</p>
              <p className="text-sm leading-relaxed">
                서울특별시 중구 을지로 27가길 22<br />대륙빌딩(주교동)
              </p>
            </div>
          </div>

          <div className="border-t border-slate-700 pt-4 mt-4">
            <p className="text-xs text-slate-400 mb-2">내선번호 안내</p>
            <div className="grid grid-cols-2 gap-2 text-xs">
              <div className="bg-slate-800/50 rounded px-3 py-2">
                <span className="text-slate-400">관리:</span>
                <span className="ml-2 font-semibold">1번</span>
              </div>
              <div className="bg-slate-800/50 rounded px-3 py-2">
                <span className="text-slate-400">도안팀:</span>
                <span className="ml-2 font-semibold">0, 2, 3, 4번</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 뉴테크 연락처 */}
      <div className="bg-gradient-to-br from-amber-600 to-amber-700 text-white rounded-lg shadow-lg p-8">
        <h3 className="text-xl font-bold mb-6 flex items-center">
          <i className="ri-flashlight-line mr-2"></i>
          뉴테크 (레이저가공)
        </h3>
        
        <div className="space-y-4">
          <div className="flex items-start">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-phone-fill text-white text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-amber-100 mb-1">고객센터</p>
              <a href="tel:02-2261-2017" className="text-lg font-bold hover:text-amber-200 transition-colors cursor-pointer">
                02-2261-2017
              </a>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-mail-line text-white text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-amber-100 mb-1">이메일</p>
              <a href="mailto:nt2017@daum.net" className="text-base hover:text-amber-200 transition-colors cursor-pointer break-all">
                nt2017@daum.net
              </a>
            </div>
          </div>

          <div className="flex items-start">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-map-pin-line text-white text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-amber-100 mb-1">주소</p>
              <p className="text-sm leading-relaxed">
                서울특별시 중구 을지로27가길 3<br />중앙프라자 1층 4호
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 운영 시간 안내 */}
      <div className="bg-slate-50 rounded-lg p-6 border border-slate-200">
        <h4 className="font-bold text-slate-900 mb-4 flex items-center">
          <i className="ri-time-line text-slate-700 mr-2"></i>
          운영 시간
        </h4>
        <div className="space-y-2 text-sm text-slate-700">
          <div className="flex justify-between">
            <span>평일</span>
            <span className="font-semibold">09:00 - 18:00</span>
          </div>
          <div className="flex justify-between">
            <span>토요일</span>
            <span className="font-semibold">09:00 - 13:00</span>
          </div>
          <div className="flex justify-between text-slate-500">
            <span>일요일 및 공휴일</span>
            <span>휴무</span>
          </div>
        </div>
      </div>
    </div>
  );
}
